import { useState, useEffect, useContext, memo } from "react";
import React from "react";
import {
  SvgArrowRight,
  SvgCamera,
  SvgBoxUnChecked,
  SvgCog6ToothEmpty,
  SvgMapMarker,
  SvgPanoramaImg,
  SvgMonitor,
} from "ui/svgs";
import { AuthContext } from "context/AuthContext";
import useSWR from "swr";
import { fetchWithParams } from "lib/fetcher";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NvrItem from "ui/nvrs/nvr-item";
import { PlusIcon } from "@heroicons/react/20/solid";
import { SideviewContext } from "context/SideviewContext";
import CameraSettingTable from "ui/cameras/setting-table";
import { clsx } from "clsx";
import PanoramaEditModal from "./panoramaEdit";
import SiteMonitoringModal from "./siteMonitoringModal";
import AutomationProvider from "context/AutomationContext";
import { Popover } from "antd";

function SiteItem({ objData }: { objData: any }) {
  const { orgid } = useParams();
  const { pathname } = useLocation();
  const isEncoding = pathname.includes("encoding");
  const orgId = orgid!;

  const [active, setActive] = useState(false);
  const [height, setHeight] = useState("0px");
  const [shouldFetch, setshouldFetch] = useState(false);
  //const [cameras, setCameras] = useState<CameraInfo[]>([]);
  const [siteMonitoringVisible, setSiteMonitoringVisible] = useState(false);
  const refContent = React.useRef<HTMLDivElement>(null);
  const { user } = useContext(AuthContext);
  const { setOpenPanel, setViewData } = useContext(SideviewContext);
  const [panoramaModalShow, setPanoramaModalShow] = useState(false);
  const navigate = useNavigate();

  function reCalcParentHeight(additionalValue) {
    if (refContent.current != null && refContent.current != undefined) {
      setHeight(
        active
          ? `${refContent.current.scrollHeight + additionalValue}px`
          : "0px",
      );
    }
  }

  function toggleAccordion() {
    setActive(!active);
    if (refContent.current != null && refContent.current != undefined) {
      // console.log('toggleAccordion active = ', active);
      setHeight(active ? "0px" : `${refContent.current.scrollHeight}px`);
    }
  }

  const rotate = active ? "rotate(90deg)" : "rotate(0)";
  function handleClick() {
    if (!data && !isEncoding) {
      setshouldFetch(true);
    } else {
      toggleAccordion();
    }
  }

  const params = `?siteId=${objData.id}&page.limit=100`;
  // make SWR key unique to make side effect work only once
  const random = React.useRef(Date.now());
  const { data, isLoading } = useSWR(
    shouldFetch ? [`/device/nvrs${params}`, user.token, orgId, random] : null,
    ([url, token, orgId]) => fetchWithParams(url, token, orgId),
    {
      revalidateOnFocus: false,
    },
  );

  useEffect(() => {
    setActive(false);
    setHeight("0px");
    console.log("pathname = ", pathname);
  }, [pathname]);

  useEffect(() => {
    if (data) {
      console.log("NVRs data = ", data);
      toggleAccordion();
    }
  }, [data]);

  return (
    <div className="mb-3 bg-zinc-50 rounded-2xl relative">
      <PanoramaEditModal
        site={objData}
        visible={panoramaModalShow}
        onClose={() => setPanoramaModalShow(false)}
      />
      <div
        className="flex justify-between w-full rounded-2xl py-3 pl-3 pr-6 cursor-pointer group"
        onClick={handleClick}
      >
        <div
          className={clsx("flex items-center", isEncoding ? "pl-7" : "pl-2")}
        >
          <SvgArrowRight
            width="22"
            style={{ transform: rotate, transition: "all 0.2s linear" }}
            className="fill-neutral-500 mr-1 flex-shrink-0"
          />
          <span className="">
            <SvgMapMarker
              width="14"
              className="fill-neutral-500 inline-block mr-2"
            />
            {objData.name}
          </span>
          <span className="text-slate-300 mx-3">|</span>
          <span>{objData.details?.address || ""}</span>
          <span className="ml-3">
            <SvgCamera
              width="19"
              className="fill-neutral-500 inline-block mr-1"
            />
            <span>Online / Offline:</span>{" "}
            <span className="text-emerald-500">
              {objData.stats?.onlineCamNum || 0}
            </span>{" "}
            /{" "}
            <span className="text-red-600">
              {objData.stats?.offlineCamNum || 0}
            </span>
          </span>
          <Popover
            title=""
            content={`${objData.stats?.underMonitorCamNum || 0}/${objData.stats?.enableMonitorCamNum || 0} cameras under monitoring. Click to manage`}
          >
            <span
              className="ml-3 hover:bg-gray-200 p-1 rounded-xl"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();
                setSiteMonitoringVisible(true);
              }}
            >
              <SvgMonitor
                width="19"
                className="fill-neutral-500 inline-block mr-1"
              />
              <span>Monitoring:</span>{" "}
              <span className="text-emerald-500">
                {objData.stats?.underMonitorCamNum || 0}
              </span>{" "}
              / <span>{objData.stats?.enableMonitorCamNum || 0}</span>
            </span>
          </Popover>

          {isLoading && (
            <div
              className="text-blue-500 ml-4 inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
              role="status"
            ></div>
          )}
        </div>
        <div>
          <div className="invisible2 group-hover:visible flex items-center">
            <span
              className="p-1 rounded-full hover:bg-neutral-200 text-neutral-500"
              onClick={(e) => {
                e.preventDefault();
                navigate(
                  `/dashboard/customers/${orgId}/sites/${objData.id}/nvrs/create`,
                );
              }}
            >
              <PlusIcon className="h-6" />
            </span>
            <span
              className="p-1 rounded-full hover:bg-neutral-200 text-neutral-500"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setPanoramaModalShow(true);
              }}
            >
              <SvgPanoramaImg />
            </span>
            <button
              className="p-1 rounded-full hover:bg-neutral-200 text-neutral-500"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                console.log("setting clicked");
                const sideviewData = {
                  type: "edit-site",
                  title: "Site Settings",
                  orgId: orgId,
                  siteId: objData.id,
                  objData: objData,
                };
                setViewData(sideviewData);
                setOpenPanel(true);
              }}
            >
              <SvgCog6ToothEmpty width="24" />
            </button>
          </div>
        </div>
      </div>
      <div
        ref={refContent}
        className="overflow-hidden"
        style={{ maxHeight: `${height}`, transition: "max-height 0.4s ease" }}
      >
        {!isEncoding && data && data.data && data.page.total == 0 && (
          <div className="text-sm text-center text-neutral-400">No Nvrs</div>
        )}
        {!isEncoding && data && data.data && data.page.total > 0 && (
          <div className="px-7 mt-2">
            <div className="flex justify-between text-sm text-neutral-500 border-b border-neutral-200 gap-1  text-left">
              <div className="min-w-[25%] 2xl:w-4/12 2x:min-w-[33.33%]">
                Devices
              </div>
              <div className="w-[16.67%] 2xl:w-1/12 min-w-[16.67%] 2xl:min-w-[8.33%] text-left">
                Status
              </div>
              <div className="w-3/12 text-left">Model</div>
              <div className="w-1/12 text-left">Vendor</div>
              <div className="w-[12.5%] text-left">License</div>
              <div className="w-[12.5%] text-right">Action</div>
            </div>

            {data.data.map((data: any) => (
              <AutomationProvider>
                <NvrItem
                  siteId={objData.id}
                  objData={data}
                  key={data.id}
                  reCalcParentHeight={reCalcParentHeight}
                />
              </AutomationProvider>
            ))}
          </div>
        )}
        {isEncoding && (
          <CameraSettingTable
            siteId={objData.id}
            active={active}
            reCalcParentHeight={reCalcParentHeight}
          />
        )}
      </div>
      <SiteMonitoringModal
        visible={siteMonitoringVisible}
        onClose={() => setSiteMonitoringVisible(false)}
        onRefresh={() => {}}
        site={objData}
      />
    </div>
  );
}

export default memo(SiteItem);
